﻿import React from "react";
import { i18n } from "../../helpers/localisation-helpers";
import { useTypedSelector } from "../../hooks/useTypeSelector";
import ProductCaseStudy from "./ProductCaseStudy";

const ProductCaseStudies = () => {
    const { productData } = useTypedSelector((state) => state.product);
    const [expandCaseStudies, setExpandCaseStudies] = React.useState<boolean>(false);

    const handleExpandCaseStudies = () => {
        setExpandCaseStudies(!expandCaseStudies);
    };

    return (     
        <>
            <div className="onepcssgrid-1300" style={{ overflow: "hidden" }}>

                <div className="onerow">
                    <div className="col12 last">
                        <div className="case-studies">
                            <a id="casestudies"></a>
                            <div className="reviews">
                                <h2>
                                    {i18n("Resource.CaseStudies", productData.PageLocalisations)}
                                </h2>
                                {productData.CaseStudies.map((caseStudy, index) => {
                                    return (
                                        <ProductCaseStudy
                                            key={index}
                                            caseStudyId={caseStudy.CaseStudyID}
                                            caseStudyUrl={caseStudy.OldSystem
                                                ? caseStudy.UrlSlug == null || caseStudy.UrlSlug == ""
                                                    ? `/case-studies/${caseStudy.CaseStudyID}-${caseStudy.SanitisedCaseStudyTitle}`
                                                    : `/case-studies/${caseStudy.UrlSlug}`
                                                : `/case-studies/${caseStudy.UrlSlug}`}
                                            thumbUrl={caseStudy.ThumbUrl}
                                            itemIndex={index + 1}
                                            title={caseStudy.CaseStudyTitle}
                                            urlSlug={caseStudy.UrlSlug}
                                            intro={caseStudy.CaseStudyIntro}
                                            isOldSystem={caseStudy.OldSystem}
                                            expandCaseStudies={expandCaseStudies}
                                        />
                                    )
                                })}

                                {productData.CaseStudies.length > 3 && <div className="expanderbuttoncontainer">
                                    <a onClick={() => handleExpandCaseStudies()} className="btn expander">{!expandCaseStudies ? "Show more" : "Show less"}</a>
                                </div>}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default ProductCaseStudies;